import {StorageManagerGateway} from '../../../core-logic/gateways/app-services/storage-manager-gateway';
import {from, Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {map, mapTo, switchMap} from 'rxjs/operators';
import {Preferences} from '@capacitor/preferences';
import {UserModel} from '../../../core-logic/models/user/user-model';

@Injectable({ providedIn: 'root'})
export class StorageManagerGatewayCapacitor extends StorageManagerGateway {
  private readonly currentUserKeyStorage = 'currentUser';
  private readonly businessViewModeKeyStorage = 'businessView';
  constructor() {
    super();
  }

  get(key: string): Observable<any> {
    return from(Preferences.get({key})).pipe(map(value =>  JSON.parse(value.value)));
  }

  set(key: string, value: any): Observable<boolean> {
    return from(Preferences.set({key, value: JSON.stringify(value)})).pipe(mapTo(true));
  }

  remove(key: string): Observable<boolean> {
    return from(Preferences.remove({key})).pipe(mapTo(true));
  }

  getCurrentUser(): Observable<UserModel> {
    return from(Preferences.get({key: this.currentUserKeyStorage})).pipe(map(value =>  JSON.parse(value.value) as UserModel));
  }

  setCurrentUser(userModel: UserModel): Observable<boolean> {
    return from(Preferences.set({key: this.currentUserKeyStorage, value: JSON.stringify(userModel)})).pipe(mapTo(true));
  }

  removeCurrentUser(): Observable<boolean> {
    return from(Preferences.remove({key: this.currentUserKeyStorage})).pipe(mapTo(true));
  }

  setBusinessViewMode(): Observable<boolean> {
    return from(Preferences.set({key: this.businessViewModeKeyStorage, value: JSON.stringify(true)})).pipe(mapTo(true));
  }

  unsetBusinessViewMode(): Observable<boolean> {
    return from(Preferences.set({key: this.businessViewModeKeyStorage, value: JSON.stringify(false)})).pipe(mapTo(true));
  }

  getBusinessViewMode(): Observable<boolean> {
    return from(Preferences.get({key: this.businessViewModeKeyStorage})).pipe(map(value =>  JSON.parse(value.value)));
  }

  clear(): Observable<boolean> {
    return from(Preferences.clear()).pipe(mapTo(true));
  }

  updateCurrentUserFcmToken(fcmToken: string ): Observable<boolean> {
      return this.getCurrentUser().pipe(switchMap(currentUser => {
        currentUser.fcm_token = fcmToken;
        return this.setCurrentUser(currentUser);
      }));
  }
}
